module.exports = __webpack_public_path__ + "assets/cad172226937eb64bc32595dfa149668-DSC_0752.jpg";